/* 
Model defined for Maintaining Branch Requests. It can also be used for transferring model
*/

export class BranchRequestModel {
    name: string;
    email: string;
    address: string;
    mobile: string;
    pinCode: string;
    city: string;
    partnerId: string;
    latitude: string;
    longitude: string;
    constructor(name: string, email: string, address: string, mobile: string, pinCode: string,
        city: string, partnerId: string, latitude: string, longitude: string) {
        this.name = name;
        this.email = email;
        this.address = address;
        this.mobile = mobile;
        this.pinCode = pinCode;
        this.city = city;
        this.partnerId = partnerId;
        this.latitude = latitude;
        this.longitude = longitude;
    }
}



// WEBPACK FOOTER //
// ./src/app/_models/branch/BranchRequestModel.ts